import React, { Component } from 'react';

import { Card, Grid, Table, TableBody, TableRow, TableCell, Button } from '@material-ui/core';

import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';

import shortid from 'shortid';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import history from '../../../history';
import { acceptTerms, getMerchantProfileFeeItemList } from '../../services/iDepositService';
import NumberFormat from 'react-number-format';
import { setUserData } from '../../redux/actions/UserActions';
import localStorageService from '../../services/localStorageService';

class AcceptTerms extends Component {
  state = {
    reviewed: false,
    error: '',
    merchantFeeItemList: [],
    checking: '',
    routing: '',
    paymentInfoSaved: 'N'
  };

  componentDidMount() {
    this.loadMerchantFeeItemList();
    if (this.props.user.terms !== undefined) {
      this.setState({ paymentInfoSaved: this.props.user.terms.paymentInfoSaved });
    }
  }

  loadMerchantFeeItemList = () => {
    getMerchantProfileFeeItemList().then(response => {
      if (response.status !== 200) {
        // error
        this.setState({ error: response.data.message });
      } else {
        // good
        this.setState({ merchantFeeItemList: response.data });
      }
    });
  };

  handleChange = event => {
    event.persist();
    this.setState({ [event.target.name]: event.target.value });
    this.setState({ error: '' });
    this.setState({ info: '' });
  };

  handleSubmit = event => {
    this.acceptTerms(event);
  };

  reviewTerms = event => {
    window.open(this.props.user.terms.url, '_blank');
    this.setState({ reviewed: true });
  };

  acceptTerms = event => {
    this.setState({ info: 'Please wait...' });

    let request = {
      termsId: this.props.user.terms.termsId,
      checkingAccount: this.state.checking,
      routingNumber: this.state.routing
    };

    acceptTerms(request).then(response => {
      this.setState({ info: '' });
      if (response.status !== 200) {
        console.error(response);
        this.setState({ error: response.data.message });
      } else {
        this.props.user.terms.accepted = 'Y';
        localStorageService.setItem('auth_user', this.props.user);
        this.props.setUserData(this.props.user);
        history.push({ pathname: '/' });
      }
    });
  };
  render() {
    let { reviewed, checking, routing } = this.state;
    return (
      <div className='signup flex flex-center w-100 h-100vh'>
        <div className='p-8'>
          <Card className='signup-card position-relative y-center'>
            <Grid container>
              <Grid item lg={5} md={5} sm={5} xs={12}>
                <div className='p-32 flex flex-center flex-middle h-100'>
                  <img src='/assets/images/Tunl-Logo.png' alt='' />
                </div>
              </Grid>
              <Grid item lg={7} md={7} sm={7} xs={12}>
                <div className='bg-error text-center text-white'>{this.state.error}</div>
                <div className='bg-green text-center text-white'>{this.state.info}</div>
                <div className='p-36 h-100 bg-light-gray'>
                  <h4>Please Review and Accept</h4>
                  <div>
                    {this.state.merchantFeeItemList.length > 0 && (
                      <Table className='table' style={{ whiteSpace: 'pre', minWidth: '150px' }}>
                        <TableBody>
                          {this.state.merchantFeeItemList.map((merchantFeeItem, index) => (
                            <TableRow key={shortid.generate()}>
                              <TableCell>{merchantFeeItem.feeItem.name}</TableCell>
                              <TableCell align={'center'}>{merchantFeeItem.feeItem.billInterval}</TableCell>
                              <TableCell align={'right'}>
                                <NumberFormat
                                  value={merchantFeeItem.fee}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  prefix={'$'}
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    )}

                    <ValidatorForm ref='form' onSubmit={this.handleSubmit} onError={errors => null}>
                      {this.state.merchantFeeItemList.length > 0 && this.state.paymentInfoSaved === 'N' && (
                        <Grid container>
                          <TextValidator
                            className='mb-16 w-100'
                            label='Checking Account #'
                            onChange={this.handleChange}
                            type='text'
                            name='checking'
                            value={checking}
                            validators={['required', 'minStringLength: 6', 'maxStringLength: 17']}
                            errorMessages={['this field is required']}
                          />
                          <TextValidator
                            className='mb-16 w-100'
                            label='Routing #'
                            onChange={this.handleChange}
                            type='text'
                            name='routing'
                            value={routing}
                            validators={['required', 'minStringLength: 9', 'maxStringLength: 9']}
                            errorMessages={['this field is required']}
                          />
                        </Grid>
                      )}

                      <br />

                      <div className='flex flex-middle'>
                        <Button className='capitalize' variant='contained' color='primary' type='button' onClick={this.reviewTerms}>
                          Review
                        </Button>
                        &nbsp;&nbsp;&nbsp;
                        <Button className='capitalize' variant='contained' color='primary' type='submit' disabled={!reviewed}>
                          Accept
                        </Button>
                      </div>
                    </ValidatorForm>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Card>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  login: state.login,
  user: state.user
});
export default withRouter(connect(mapStateToProps, { setUserData })(AcceptTerms));
